import React from 'react';
import Header from './Header';
import Footer from './Footer';
import SvgFilters from './SvgFilters';

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col bg-ivory">
      <SvgFilters />
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
};

export default Layout;
